import React from 'react';
import './caliItem.css'

const CaliItem = (props) => {
const dayNumber = new Date(props.western_date).getDate(); // зөвхөн өдрийг харуулах
const today = new Date().toLocaleDateString('en-CA');     // хэдний өдрийг харуулах
const datePart = props.western_date.split('T')[0]         // Огноо форматыг засах
const isToday = datePart === today;


// const date = new Date(props.western_date);
// const garagMap = {
//     1: "Даваа",
//     2: "Мягмар",
//     3: "Лхагва",
//     4: "Пүрэв",
//     5: "Баасан",
//     6: "Бямба",
//     7: "Ням",
// }
// const garag = garagMap[date.getDay()];


// console.log('dayNumber', dayNumber)
// console.log('isToday:', isToday)
// console.log('western_day', props.western_date)
    return (
        <tr  style={{backgroundColor: isToday ? 'grey': '', color: isToday? 'white': ''}} > 
            <th>{props.name_arga}<hr/>{props.name_bilig}</th>
            <td>{props.bilig_day}</td>          
            <td>{dayNumber}</td>      
            <td>{props.jil_odor}</td>   
            <td>{props.duvzi_od }</td>
            <td>{props.jedzi_od}</td>
            <td>{props.suudal}</td>
            <td>{props.menge }</td>
            <td>{props.barildlaga }</td>
            <td>{props.sh_barildlaga}</td> 
            <td>{props.sunrise.substring(0 ,5)} - {props.sunset.substring(0 ,5)}</td>
            <td>{props.moonrise.substring(0 ,5)} - {props.moonset.substring(0 ,5)}</td>
            <td>{props.ezen_odor}</td>
            <td>{props.mor_gargah}</td>
            <td>{props.udriin_ur}</td>                       
        </tr> 
        // <tr>
        //     {/* <th></th> */}
        //     <th>Билгийн <br/> өдөр гараг</th>
        //     <th>Аргын <br/>өдөр гараг</th> 
        //     <th>Жил өдөр</th> 
        //     <th>Дүвзий | саран</th> 
        //     <th>Жэдзий | саран</th>   
        //     <th>Суудал</th> 
        //     <th>Мэнгэ</th> 
        //     <th>Барилдлага</th> 
        //     <th>Шүтэн Барилдлага</th> 
        //     <th>Мөр гаргах</th> 
        //     <th>Наран <br/> ургах/шингэх</th> 
        //     <th>Саран <br/> ургах/шингэх</th> 
        //     <th>Эзэн өдөр</th>   
        //     <th>Өдрийн үр</th>      
        // </tr>    
        // <main className='ll'>
        //     <tr>
        //         <td className="label">Билгийн <br/> өдөр гараг</td>
        //         <td>{props.bilig_day}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Аргын <br/> өдөр гараг</td>
        //         <td>{dayNumber}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Жил өдөр</td>
        //         <td>{props.jil_odor}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Дүвзий | саран</td>
        //         <td>{props.duvzi_od }</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Жэдзий | саран</td>
        //         <td>{props.jedzi_od }</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Суудал</td>
        //         <td>{props.suudal}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Мэнгэ</td>
        //         <td>{props.menge }</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Барилдлага</td>
        //         <td>{props.barildlaga }</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Шүтэн Барилдлага</td>
        //         <td>{props.sh_barildlaga}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Мөр гаргах</td>
        //         <td>{props.garag }</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Наран <br/> ургах/шингэх</td>
        //         <td>{props.sunrise }-{props.sunset}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Саран <br/> ургах/шингэх</td>
        //         <td>{props.moonrise}-{props.moonset}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Эзэн өдөр</td>
        //         <td>{props.ezen_odor}</td>
        //     </tr>
        //     <tr>
        //         <td className="label">Өдрийн үр</td>
        //         <td>{props.udriin_ur}</td>
        //     </tr>   
        // </main>  
    )
}

export default CaliItem;
// {/* <tr>
//                     {/* <th></th> */}
//                     <th>Билгийн <br/> өдөр гараг</th>
//                     <th>Аргын <br/>өдөр гараг</th> 
//                     <th>Жил өдөр</th> 
//                     <th>Дүвзий | саран</th> 
//                     <th>Жэдзий | саран</th>   
//                     <th>Суудал</th> 
//                     <th>Мэнгэ</th> 
//                     <th>Барилдлага</th> 
//                     <th>Шүтэн Барилдлага</th> 
//                     <th>Мөр гаргах</th> 
//                     <th>Наран <br/> ургах/шингэх</th> 
//                     <th>Саран <br/> ургах/шингэх</th> 
//                     <th>Эзэн өдөр</th>   
//                     <th>Өдрийн үр</th>      
//                 </tr>    
         
//                 <tr id='cales-body'> 
//                     {/* <td>{props.month_id}</td> */}
//                     <td>{props.bilig_day }</td>          
//                     <td>{dayNumber }</td>      
//                     <td>{props.jil_odor}</td>   
//                     <td>{props.duvzi_od }</td>
//                     <td>{props.jedzi_od }</td>
//                     <td>{props.suudal}</td>
//                     <td>{props.menge }</td>
//                     <td>{props.barildlaga }</td>
//                     <td>{props.sh_barildlaga}</td> 
//                     <td>{props.garag }</td>
//                     <td>{props.sunrise }-{props.sunset}</td>
//                     <td>{props.moonrise}-{props.moonset}</td>
//                      <td>{props.ezen_odor}</td>
//                      <td>{props.urdiin_ur}</td>
//                     <td>{props.day_number }</td>                             
//                 </tr> */}